const convertYouTubeUrl = (url: string): string => {
  const regExp = /^.*(youtu.be\/|youtube\.com\/watch\?v=)([^#&?]*).*/
  const match = url.match(regExp)
  if (match && match[2].length === 11) {
    return `https://www.youtube.com/embed/${match[2]}`
  }
  return url // Return original URL if not matching
}

// Conversion function for Vimeo URLs
const convertVimeoUrl = (url: string): string => {
  const regExp = /vimeo.com\/(\d+)/
  const match = url.match(regExp)
  if (match && match[1]) {
    return `https://player.vimeo.com/video/${match[1]}`
  }
  return url // Return original URL if not matching
}

// Conversion function for Dailymotion URLs
const convertDailymotionUrl = (url: string): string => {
  const regExp = /dailymotion.com\/video\/(\w+)/
  const match = url.match(regExp)
  if (match && match[1]) {
    return `https://www.dailymotion.com/embed/video/${match[1]}`
  }
  return url // Return original URL if not matching
}
export const convertUrl = (inputUrl: string) => {
  let url = inputUrl
  if (url.includes("youtube.com") || url.includes("youtu.be")) {
    url = convertYouTubeUrl(url)
  } else if (url.includes("vimeo.com")) {
    url = convertVimeoUrl(url)
  } else if (url.includes("dailymotion.com")) {
    url = convertDailymotionUrl(url)
  }
  return url
}
